import { isSome, v2_useAuthorizedCustomer } from '@crocodille/common';
import AppLayoutHeaderDivider from '@layouts/app-layout/app-layout-header-divider';
import React from 'react';

import CustomerStatus from '../customer-status/customer-status';
import LoginButton from '../login-button/login-button';
import styles from './auth-status.module.scss';

const AuthStatus: React.FC = () => {
  const { data: customerProfile } = v2_useAuthorizedCustomer();

  return (
    <>
      <div className={styles.container}>
        {isSome(customerProfile) ? (
          <CustomerStatus
            firstName={customerProfile.firstName}
            lastName={customerProfile.lastName}
          />
        ) : (
          <LoginButton />
        )}
      </div>
      <AppLayoutHeaderDivider />
    </>
  );
};

export default AuthStatus;
